"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetBaseToJSON = exports.TargetBaseFromJSONTyped = exports.TargetBaseFromJSON = exports.instanceOfTargetBase = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the TargetBase interface.
 */
function instanceOfTargetBase(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfTargetBase = instanceOfTargetBase;
function TargetBaseFromJSON(json) {
    return TargetBaseFromJSONTyped(json, false);
}
exports.TargetBaseFromJSON = TargetBaseFromJSON;
function TargetBaseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
    };
}
exports.TargetBaseFromJSONTyped = TargetBaseFromJSONTyped;
function TargetBaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
    };
}
exports.TargetBaseToJSON = TargetBaseToJSON;
